<section class="titleS">
    <h1>Tuia si chiparosi</h1>
</section>


<section class="sec">

    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/tuja/TuiaSmaragd.jpg" class="img-fluid" alt="tuja">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Tuia</h1>
                                <p>Smaragd</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Tuia este un conifer cu frunzele așezate în scara, orientate catre varful tulpinii, mereu
                            verzi.</p>
                        <p>Este rezistent la temperaturi înalte, dar si scazute. Poate atinge inaltimi considerabile.
                            Coroana poate fi lesne controlata prin tunderi repetate si devine extrem de spectaculoasa
                            daca i se dau forme geometrice sau spiralate.</p>
                        <p>Tuia este una dintre cele mai utilizate plante decorative din gradinile lumii pentru forma sa
                            unica, piramidala.</p>
                        <p>De altfel, tuia este adesea folosita pentru a crea un grad viu, un paravan in gradina care sa
                            ne fereasca de ochii curiosilor.</p>
                        <p> O planta rezistenta, care se pliaza pe orice climat si care necesita minima îngrijire.</p>
                        <p>Dar, imediat după ce este plantata are nevoie de apa în mod curent si este recomandat sa o
                            udati în fiecare zi, iar dupa câteva saptamani la fiecare trei zile.Tuia creste în medie
                            20-30 cm pe an.</p>


                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Tuia</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Smaragd</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>incepand cu 70</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>700-800</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>incepand cu: 40 lei</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Martie-Noiembrie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>soare,semiumbra</td>
                    </tr>

                </tbody>
            </table>

        </div>
    </div>

</section>
<hr>
<section class="sec">

    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/tuja/TuiaGlobosa.jpg" class="img-fluid" alt="tuja">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Tuia</h1>
                                <p>Danica</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Arbore de talie mica,forma sferica.</p>
                        <p>Se preteaza la aproape toate solurile, dar le prefera pe cele bine drenate si neutre. Cel mai
                            bine se comportă la soare, dar apreciaza usoara umbra de dupa-amiaza vara. Evitati umbra
                            completa. Acesta este un soi dens, sferic, cu crestere lenta. Frunzisul are culoarea
                            verde-smarald si devine bronz toamna. Se potriveste bine alaturi de pietre sau borduri, dar
                            si în ghivece. Este o alegere populara si sigura.</p>



                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Tuia</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Danica</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>20-60</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>80</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>incepand cu: 40 lei</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Martie-Noiembrie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>soare,semiumbra</td>
                    </tr>

                </tbody>
            </table>

        </div>
    </div>

</section>
<hr>
<section class="sec">

    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/tuja/TuiaNanaAurea.jpg" class="img-fluid" alt="tuja">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Tuia</h1>
                                <p>Nana Aurea</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Este un conifer cu frunzele vesnic verzi. Cresterea este înceata si compacta. Nu are nevoie
                            deloc de îngrijire. Este ideala pentru stancarii sau borduri. Se adapteaza usor la toate
                            conditiile, dar nu ii plac zonele apoase. Culoarea este galben-auriu pe timpul verii si
                            bronz iarna.</p>



                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Tuia</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Nana Aurea</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>50-100</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>180-200</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>incepand cu: 80</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Martie-Noiembrie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>soare,semiumbra</td>
                    </tr>

                </tbody>
            </table>

        </div>
    </div>

</section>
<hr>

<!-- chiparos -->
<!-- leylandy -->
<section class="sec">

    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/tuja/Leylandii.jpg" class="img-fluid" alt="tuja">

                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Chiparos</h1>
                                <p>Leylandii</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Este un conifer cu frunzele vesnic verzi. Cresterea este rapida. Pentru un coronament des
                            necesita tundere. Se adapteaza usor la toate conditiile.</p>
                        <p>Este una dintre cele mai cunoscute specii decorative folosite ca si gard viu.</p>


                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Chiparos</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Leylandii</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>incepand cu 70</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>700-800</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>incepand cu: 50</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Martie-Noiembrie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>soare,semiumbra</td>
                    </tr>

                </tbody>
            </table>

        </div>
    </div>

</section>
<hr>
<!-- chiparos albastru -->
<section class="sec">

    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/tuja/chiparosblue.jpg" class="img-fluid" alt="tuja">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Chiparos</h1>
                                <p>Chiparos albastru</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Chamaecyparis lawsoniana Columnaris este o specie arbustiva ornamentala cunoscuta si sub
                            numele de Chiparos Albastru Columnaris. Este una dintre cele mai cunoscute specii decorative
                            folosite ca si gard viu. Surprinde prin nuantele de albastru si prin aspectul sau zvelt,
                            dens. Poate fi plantat si solitar, insa in grupuri frumusetea si utilitatea lor cresc.</p>



                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Chiparos</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Chiparos albastru</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>100-120,120-140cm</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>700-800</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>incepand cu: 50</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Martie-Noiembrie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>soare,semiumbra</td>
                    </tr>

                </tbody>
            </table>

        </div>
    </div>

</section>
<hr>

<section class="sec">

    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/tuja/Chiparosbicolor.jpg" class="img-fluid" alt="tuja">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Chiparos</h1>
                                <p>Chiparos bicolor</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Chiparosul este una dintre cele mai cunoscute specii decorative folosite ca si gard viu,
                            suporta foarte bine tunderea. Poate fi plantat si solitar, insa in grupuri frumusetea si
                            utilitatea lor cresc.</p>



                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Chiparos</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Chiparos bicolor</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>80-100 cm</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>200</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>incepand cu: 250</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Martie-Noiembrie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>soare,semiumbra</td>
                    </tr>

                </tbody>
            </table>

        </div>
    </div>

</section>
<hr>

<section class="sec">

    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/tuja/chiparos-chamaecyparis-lawsoniana-ellwoodii.jpg" class="img-fluid"
                            alt="tuja">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Chiparos</h1>
                                <p>lawsoniana ellwoodii</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Conifer cu crestere lenta, originar din America de Nord. Suporta tundere de 2 ori pe an.</p>
                        <p>Acest chiparos are frunzele formate din solzi mici, ce se suprapun de culoare verde
                            albastrui.</p>



                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Chiparos</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Chamaecyparis Lawsoniana Ellwoodii</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>70-100</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>600-800</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>incepand cu: 80</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Martie-Noiembrie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>soare,semiumbra</td>
                    </tr>

                </tbody>
            </table>

        </div>
    </div>

</section>
<hr>
<section class="sec">

    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/tuja/Cupressus WILMA GOLDCREST.jpg" class="img-fluid" alt="tuja">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Chiparos</h1>
                                <p>Cupressus WILMA GOLDCREST</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Frunzele sunt persistente de culoare galben-auriu-verzui. Prin strivire frunzele emana un
                            miros cu o aroma de lamaie.Atinge 5m in 10 ani si isi continua cresterea pana la varsta de
                            20 de ani.</p>




                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Chiparos</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Cupressus Wilma Goldcrest</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>incepand cu: 50-80cm</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>700-800</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>incepand cu: 80</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Martie-Noiembrie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>soare,semiumbra</td>
                    </tr>

                </tbody>
            </table>

        </div>
    </div>

</section>
<hr>
<section class="sec">

    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/tuja/cupressocyparispom-pon.jpg" class="img-fluid" alt="tuja">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Chiparos</h1>
                                <p>Pom-Pon</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Este un conifer cu frunzele vesnic verzi. Cresterea este rapida. Pentru un coronament des
                            necesita tundere. Se adapteaza usor la toate conditiile.</p>
                        <p>Este una dintre cele mai cunoscute specii decorative folosite ca si gard viu. Datorita
                            faptului ca suporta foarte bine tunderea poate fi modelat usor.</p>



                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Chiparos</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Cupressocyparis leilandyi pom-pon</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>100, 120-140</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>700-800</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>incepand cu: 250</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Martie-Noiembrie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>soare,semiumbra</td>
                    </tr>

                </tbody>
            </table>

        </div>
    </div>

</section>
<hr>









<section class="sec" id="ultim">

    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/tuja/Grasilis.jpg" class="img-fluid" alt="Grasilis">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Chiparos</h1>
                                <p>Nana Grasilis</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Chamaecyparis Obtusa Nana Grasilis cunoscut si sub numele de chiparos japonez este perfect in
                            orice colt din gradina.</p>
                        <p>Frunzele sunt de un verde luxuriant, lucios in forma de scoici plate.</p>
                        <p>Are o crestere lenta ,7-15cm/an.</p>
                        <p>Rezistent la inghet.</p>

                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Chiparos</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Nana Grasilis</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>30-40cm</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>150-180</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>incepand cu: 120</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Martie-Noiembrie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>soare,semiumbra</td>
                    </tr>

                </tbody>
            </table>

        </div>
    </div>

</section>
<hr>